export default {
  strict: true,
  namespaced: true,
  state: {
    rsvpId: '',
    basicInfo: {
      tripInfo: {
        id: '',
        brandId: '',
        brand: '',
        brandColor: '',
        packageId: '',
        bookedThrough: '',
        status: '',
        bidId: '',
        bidStatus: '',
        created: '',
        pickupDate: '',
        fare: '',
        driverPayment: '',
        driverBonus: '',
        paymentBonus: '',
        tip: '',
        airportFee: '',
        pickupFee: '',
        credits: '',
        serviceType: '',
        serviceTypeId: '',
        serviceLabel: '',
        serviceCode: '',
        pickup: '',
        dropoff: '',
        aptGate: '',
        eta: '',
        beThereTime: '',
        distance: '',
        airline: '',
        airlineCode: '',
        flightNo: '',
        passenger: '',
        luggage: '',
        notes: '',
        serviceArea: '',
        wheelchair: '',
        serviceDog: '',
        overridePrice: '',
        overridePayment: '',
        rating: '',
        userReview: '',
        isCharter: false,
        isRental: false,
        optinShared: false
      },
      customerInfo: {
        id: '',
        firstName: '',
        lastName: '',
        creditCard: '',
        cardTitle: '',
        creditCardId: '',
        email: '',
        mobile: ''
      },
      guestInfo: {
        firstname: '',
        lastName: '',
        mobile: ''
      },
      driverInfo: {
        id: '',
        firstName: '',
        lastName: '',
        rating: '',
        driversLicense: '',
        licensePlate: '',
        make: '',
        model: '',
        email: '',
        mobile: '',
        photo: ''
      },
      businessInfo: {
        id: '',
        corporateName: '',
        firstName: '',
        lastName: '',
        mobile: ''
      },
      otherInfo: {
        externalId: '',
        alternatePhone: ''
      },
    },
    showPaymentBreakdown: false,
    flightStatus: {
      status: '',
      departureAirport: '',
      arrivalAirport: '',
      arrivalTime: ''
    },
    flightManual: false,
    showFlightStatus: false,
    sendEmail: {
      show: false,
      message: ''
    },
    sendNoShow: {
      showModal: false,
      loading: false,
      showMsg: false,
      message: '',
      forceHide: false
    },
    showReleaseModal: false,
    rsvpAction: {
      show: false,
      message: ''
    },
    emailRecipient: {
      show: false,
      title: '',
      selected: 'customer',
      email: ''
    },
    extraStops: [],
    isTerminal: false,
    currency: {
      airportFee: 0,
      amount: 0,
      credit: 0,
      currency: 'USD',
      currencyRate: 1,
      gasFee: 0,
      pickupFee: 0,
      tipAmount: 0,
      travelInsurance: 0,
      symbol: '$'
    },
    useLocalCurrency: false
  },
  mutations: {
    resetBasicInfo(state) {
      state.rsvpId = ''
      state.basicInfo = {
        tripInfo: {
          id: '',
          brandId: '',
          brand: '',
          brandColor: '',
          packageId: '',
          bookedThrough: '',
          status: '',
          bidId: '',
          bidStatus: '',
          created: '',
          pickupDate: '',
          fare: '',
          driverPayment: '',
          driverBonus: '',
          paymentBonus: '',
          tip: '',
          airportFee: '',
          pickupFee: '',
          credits: '',
          serviceType: '',
          serviceTypeId: '',
          serviceLabel: '',
          serviceCode: '',
          pickup: '',
          dropoff: '',
          aptGate: '',
          eta: '',
          beThereTime: '',
          distance: '',
          airline: '',
          airlineCode: '',
          flightNo: '',
          passenger: '',
          luggage: '',
          notes: '',
          serviceArea: '',
          wheelchair: '',
          serviceDog: '',
          overridePrice: '',
          overridePayment: '',
          rating: '',
          userReview: '',
          isCharter: false,
          isRental: false,
          optinShared: false
        },
        customerInfo: {
          id: '',
          firstName: '',
          lastName: '',
          creditCard: '',
          email: '',
          mobile: ''
        },
        guestInfo: {
          firstName: '',
          lastName: '',
          mobile: ''
        },
        driverInfo: {
          id: '',
          firstName: '',
          lastName: '',
          rating: '',
          driversLicense: '',
          licensePlate: '',
          make: '',
          model: '',
          email: '',
          mobile: '',
          photo: ''
        },
        businessInfo: {
          id: '',
          corporateName: '',
          firstName: '',
          lastName: '',
          mobile: ''
        },
        otherInfo: {
          externalId: '',
          alternatePhone: ''
        }
      }
      state.flightStatus = {
        status: '',
        departureAirport: '',
        arrivalAirport: '',
        arrivalTime: ''
      }
      state.flightManual = false
      state.sendEmail = {
        show: false,
        message: ''
      }
      state.sendNoShow = {
        showModal: false,
        loading: false,
        showMsg: false,
        message: '',
        forceHide: false
      }
      state.extraStops = []
    },
    setRsvpDetails(state, value) {
      state.rsvpId = value.rsvpId
      state.basicInfo = value.basicInfo
    },
    setShowPaymentBreakdown(state, value) {
      state.showPaymentBreakdown = value
    },
    setFlightStatus(state, value) {
      state.flightStatus = value
    },
    setShowFlightStatus(state, value) {
      state.showFlightStatus = value
    },
    setFlightManual(state, value) {
      state.flightManual = value
    },
    setSendEmail(state, value) {
      state.sendEmail = {
        show: value.show,
        message: value.message
      }
    },
    setSendNoShow(state, value) {
      state.sendNoShow = {
        showModal: value.showModal,
        loading: value.loading,
        showMsg: value.showMsg,
        message: value.message,
        forceHide: value.forceHide
      }
    },
    showReleaseConfirmation(state) { state.showReleaseModal = true },
    hideReleaseConfirmation(state) { state.showReleaseModal = false },
    setRsvpAction(state, value) {
      state.rsvpAction = {
        show: value.show,
        message: value.message
      }
    },
    setEmailRecipientField (state, data) { state.emailRecipient[data.field] = data.value },
    setExtraStops (state, value) {
      state.extraStops = value
    },
    setIsTerminal (state, value) { state.isTerminal = value },
    setCurrency (state, data) {
      for (let field in data) {
        state.currency[field] = data[field]
      }
    },
    setLocalCurrency (state, val) {
      state.useLocalCurrency = val
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/basic-information.js